const steps = [
    {id: 1, title: 'Customer ID Changes', name: 'cusid_changes'},
    {id: 2, title: 'Purchase with Vault', name: 'purchase_v'},
    {id: 3, title: 'Pre-Authorization with Vault', name: 'preauth_v'},
    {id: 4, title: 'Vault Independent Refund CC', name: 'v_indref'},
    {id: 5, title: 'Force Post with Vault', name: 'force_post_v'},
    {id: 6, title: 'Card Verification with Vault', name: 'card_ver_v'},
    {id: 7, title: 'Hosted Tokenization', name: 'hosted_tok'},
]

export default steps